import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import NoData from "../../assets/NoData/NoData";
import { createNotification } from "../notifications/notifications";
import Select from 'react-select'
import styles from '../shared/ProgressReport.module.scss';
import { Pagination } from "../../assets/Pagination/Pagination";

const SupportStudyDis = ({
  fetchEducationPrograms,
  fetchCurriculum,
  fetchDisciplines,
  fetchYears,
  fetchEdy,
  fetchCourse,
  fetchMetaCourse,
  discipline,
  disciplines,
  disciplineRPD,
  educationYears,
  curriculum,
  schoolYears,
  pagesCount,
  educationPrograms,
  ...props
}) => {

  const { isLoading } = props;
  const [curriculumId, setCurriculumId] = useState(0)
  const [disciplineId, setDisciplineId] = useState(0)
  const [disciplineRPDId, setDisciplineRPDId] = useState(0)
  const [eyId, setEyId] = useState(0)
  const [syid, setSyid] = useState(0)
  const [schoolYearId, setSchoolYearId] = useState(0)
  const [newSchoolYears, setSchoolYears] = useState([]);
  const [valueDis, setValueDis] = useState([]);
  const [valueDisRPD, setValueDisRPD] = useState([]);
  const [numberPage, setNumberPage] = useState(0);

  const resetForm = () => {
    setCurriculumId(0)
    setDisciplineId(0)
    setDisciplineRPDId(0)
    setEyId(0)
    setSyid(0)
    setSchoolYearId(0)
    setSchoolYears([])
    setValueDis([])
    setValueDisRPD([])
    fetchYears(syid && 0)
    fetchEducationPrograms(numberPage, 0, 0)
    props.location.state = {}
  }

  useEffect(() => {
    setNumberPage(0)
  }, [curriculumId])

  useEffect(() => {
    const value = schoolYears ? [{ value: '0', label: 'Все' }, ...schoolYears.map(el => ({ value: el.syid, label: el.name })).reverse()] : schoolYears
    // ?.filter(el => el.value != 0);
    const valueDis = [{ value: '0', label: 'Все' }, ...discipline?.map(el => ({ value: el.idmetacourse, label: el.name }))]

    const valueDisRPD = [{ value: '0', label: 'Все' }, ...disciplines?.map(el => ({ value: el.value, label: el.name }))]

    setSchoolYears(value);
    setValueDis(valueDis)
    setValueDisRPD(valueDisRPD)
  }, [schoolYears, discipline, disciplines, disciplineRPD]);

  useEffect(() => {
    fetchYears()
    // fetchEducationPrograms()
    fetchEducationPrograms(numberPage, props?.location?.state?._course, props?.location?.state?._cid)
    setInitialState()
  }, [])

  useEffect(() => {
    fetchCurriculum(syid)
  }, [syid])

  console.log(valueDisRPD)  
  console.log(disciplines)  

  useEffect(() => {
    fetchEducationPrograms(numberPage, curriculumId, disciplineRPDId)
  }, [numberPage, curriculumId, disciplineRPDId]);

  //TODO  
  curriculum = [{ value: 0, label: 'Все' }, ...curriculum.map(el => ({ value: el.value, label: el.label }))]

  useEffect(() => {
    if (curriculumId) {
      fetchMetaCourse(syid, curriculumId, 0)
      fetchCourse({ syid, idcurriculum: curriculumId })
      fetchDisciplines({ idcurriculum: curriculumId, syid: syid })
      fetchEducationPrograms(numberPage, curriculumId)
    }
  }, [curriculumId, numberPage])

  useEffect(() => {
    fetchMetaCourse(syid, curriculumId, disciplineRPDId)
  }, [disciplineRPDId])

  useEffect(() => {
    if (props?.location?.state?._course) {
      setCurriculumId(props?.location?.state?._course);
    }
  }, [curriculum])

  useEffect(() => {
    if (props?.location?.state?._cid) {
      setDisciplineRPDId(props?.location?.state?._cid);
    } else if (discipline.length) {
      setDisciplineRPDId(0);
    }
  }, [props?.location?.state?._cid])

  useEffect(() => {
    if (props?.location?.state?._year) {
      setSchoolYearId(props?.location?.state?._year);
    }
  }, [props?.location?.state?._year]);

  useEffect(() => {
    if (props?.location?.state?._eyid) {
      setEyId(props?.location?.state?._eyid);
    }
  }, [props?.location?.state?._eyid]);

  useEffect(() => {
    (curriculumId && disciplineRPDId) &&
      fetchEducationPrograms(numberPage, curriculumId, disciplineRPDId)
  }, [numberPage, curriculumId, disciplineRPDId]);

  const setInitialState = () => {
    const { schoolYearId, curriculumId, disciplineRPDId, disciplineId, numberPage } = props.location.state || {}
    setSchoolYearId(schoolYearId || 0)
    setCurriculumId(curriculumId || 0)
    setDisciplineRPDId(disciplineRPDId || 0)
    setDisciplineId(disciplineId || 0)
    setNumberPage(numberPage || 0)
  }

  const goToCard = (plan) => () => {
    if (Number(schoolYearId)) {
      const state = {
        schoolYearId,
        curriculumId,
        disciplineRPDId,
        disciplineId,
        numberPage
      }

      props.history.push({
        pathname: `/disprograms/${plan.id_curriculum_course}`, state
        // pathname: `/discipline/${plan.cid}/${plan.idcurriculum}/${schoolYearId}/0`,
        // pathname: `/disprograms/${plan.cid}`, // переход сразу в Список литературы - дальн=ейшие действия через Моисеичев
        // state: {
        //   id: plan.id_curriculum_course,
        //   course: plan.idcurriculum,
        //   cid: plan.cid,
        // переход сразу в Список литературы - дальн=ейшие действия через Моисеичев
        // state: {
        //   id: plan.id_curriculum_course,
        //   course: plan.idcurriculum,
        //   cid: plan.cid,
        // }
      })
    } else {
      createNotification('error', 'Необходимо выбрать "Год набора"')
    }
  };

  const renderEducationProgramsTable = (plan, index) => (
    <tr key={index} onClick={goToCard(plan)} className="pointer">
      <td>{plan["Воен.специальн."]}</td>
      <td>{plan["Дисциплина"]}</td>
      <td>{plan["Название"]}</td>
      <td>{plan["Статус"]}</td>
      <td>{plan["Учебный план"]}</td>
      <td>{plan["Файлы"]}</td>
    </tr>
  );

  return (
    <div className="umkT">
      <p className="captions">Обеспечение учебной дисциплины литературой </p>
      <div className="plans">
        <div style={{ display: 'flex', justifyContent: 'start' }}>
          <span style={{ width: '150px' }}>Год набора:</span>
          <div className="inputs__input CURR-input">

            <Select
              placeholder='Выберите учебный год'
              noOptionsMessage={() => "ничего не найдено"}
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  borderColor: '#7b2b2a',
                  borderRadius: '50px',
                  fontSize: '13px'
                }),
              }}
              onChange={(id) => {
                setSyid(id.value)
                setSchoolYearId(id.value)
              }
              }
              value={newSchoolYears?.find(el => el.value == schoolYearId)}
              options={newSchoolYears}

            />

          </div>
        </div>


        <div style={{ display: 'flex', justifyContent: 'start' }}>
          <span style={{ width: '150px' }}>Учебный план:</span>
          <div className="inputs__input CURR-input">
            <Select
              placeholder='Выберите учебный план'
              noOptionsMessage={() => "ничего не найдено"}
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  borderColor: '#7b2b2a',
                  borderRadius: '50px',
                  fontSize: '13px'
                }),
              }}
              onChange={(id) => setCurriculumId(id.value)}
              value={curriculum?.find(el => el.value == curriculumId)}
              options={curriculum}
            />
          </div>
        </div>



        <div style={{ display: 'flex', justifyContent: 'start' }}>
          <span style={{ width: '150px' }}>Дисциплина РПД:</span>
          <div className="inputs__input CURR-input" style={{ margintLeft: '0' }}>
            <Select
              placeholder='Выберите учебную дисциплину'
              noOptionsMessage={() => "ничего не найдено"}
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  borderColor: '#7b2b2a',
                  borderRadius: '50px',
                  fontSize: '13px',

                }),
              }}

              onChange={(id) => setDisciplineRPDId(id.value)}
              value={valueDisRPD?.find(el => el.value == disciplineRPDId)}
              options={valueDisRPD}
            />
          </div>
        </div>


        <div style={{ display: 'flex', justifyContent: 'start' }}>
          <span style={{ width: '150px' }}>Дисциплина:</span>
          <div className="inputs__input CURR-input" style={{ margintLeft: '0' }}>
            <Select
              placeholder='Выберите учебную дисциплину'
              noOptionsMessage={() => "ничего не найдено"}
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  borderColor: '#7b2b2a',
                  borderRadius: '50px',
                  fontSize: '13px',

                }),
              }}

              onChange={(id) => setDisciplineId(id.value)}
              value={valueDis?.find(el => el.value == disciplineId)}
              options={valueDis}
            />

          </div>

        </div>

        <button className={styles.updateButton} style={{ float: "left", margin: "10px" }} onClick={resetForm}>Очистить поиск</button>
        <Pagination
          pageCount={pagesCount}
          numberPage={numberPage}
          onPageChange={(page) => setNumberPage(page.selected)}
        />
      </div>

      {isLoading ? (
        <div className="text-center">
          <Spinner animation="border" role="status">
            <span className="sr-only">Loading...</span>
          </Spinner>
        </div>
      ) : (
        educationPrograms && (educationPrograms.length ?
          <table className="umkT-table mt-10">
            <thead>
              <tr>
                <th>Воен.специальн.</th>
                <th>Дисциплина</th>
                <th>Название</th>
                <th>Статус</th>
                <th>Учебный план</th>
                <th>Файлы</th>
              </tr>
            </thead>
            <tbody>
              {educationPrograms.map(renderEducationProgramsTable)}
            </tbody>
          </table> : <NoData text='данные по выбранной дисциплине отсутствуют' />
        ))}
      <Pagination
        pageCount={pagesCount}
        numberPage={numberPage}
        onPageChange={(page) => setNumberPage(page.selected)}
      />
    </div>
  );
};

export default SupportStudyDis;
